import script from "./PerformanceTrends.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceTrends.vue?vue&type=script&setup=true&lang=js"

import "./PerformanceTrends.vue?vue&type=style&index=0&id=91aa0a62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91aa0a62"]])

export default __exports__